import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"fill-height",attrs:{"fluid":""}},[_c(VRow,{attrs:{"align":"center","justify":"center"}},[_c(VCol,{staticClass:"text-center",attrs:{"cols":"12","sm":"8","md":"4"}},[_c('h1',{staticClass:"display-1"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"body-1 mt-1"},[_vm._v(" "+_vm._s(_vm.description)+" ")]),(_vm.backToHome)?_c(VBtn,{staticClass:"mt-2",attrs:{"color":"primary","to":"/"}},[_vm._v(" Back to home ")]):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }